module.exports = __webpack_public_path__ + "static/media/tree lantern map.8fe0cb82.ai";